<div *ngFor="let contract of contracts" class="contract-chart-main">
  <div class="contract-chart-title">
    <div>
      <span>{{contract.contractName}}</span>
    </div>
    <div>
      <span>{{contract.quantityRemaining | number :'0.2' :'fr'}} / {{contract.quantityTotal | number :'0.2'
        :'fr'}}</span>
    </div>
  </div>
  <div class="contract-chart-progress"
    [ngClass]="{'low': (contract.percentage < 40), 'medium': (contract.percentage < 75), 'hight':  (contract.percentage < 100), 'full' :  (contract.percentage == 100)}">
    <mat-progress-bar [matTooltip]="contract.percentage.toString() + ' %'" mode="determinate"
      [value]="contract.percentage">
    </mat-progress-bar>
  </div>
</div>